import * as React from "react";
import { SketchPicker, ColorResult, Color } from "react-color";
import "./ColorPickerComponent.css";
import * as cn from "classnames";

export interface ColorPickerComponentProps {
    value: string;
    onChange: (color: Color) => void;
}

export interface ColorPickerComponentState {
    displayColorPicker: boolean;
    color: ColorResult;
}

export class ColorPickerComponent extends React.Component<ColorPickerComponentProps, ColorPickerComponentState> {
    constructor(props: ColorPickerComponentProps) {
        super(props);
        this.state = {
            displayColorPicker: false,
            color: undefined
        };
    }

    componentWillMount() {
        this.setState({
            ...this.state,
            color: {
                ...this.state.color,
                hex: this.props.value
            }
        });
    }

    handleClick = () => {
        this.setState({
            ...this.state,
            displayColorPicker: !this.state.displayColorPicker
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            displayColorPicker: false
        });
    };

    handleChange = (color: ColorResult) => {
        this.setState({
            ...this.state,
            color: color
        });

        this.props.onChange(color.hex);
    };

    render() {
        const { value } = this.props;

        return (
            <div>
                <div className={cn("swatch", value ? "" : "no-color")} onClick={this.handleClick}>
                    <div
                        className="color-block"
                        style={value && this.state.color ? { backgroundColor: this.state.color.hex } : {}}
                    >
                        {value ? "" : "Select color"}
                    </div>
                </div>
                {this.state.displayColorPicker ? (
                    <div className="popover">
                        <div className="cover" onClick={this.handleClose} />
                        <SketchPicker color={value} onChange={this.handleChange} />
                    </div>
                ) : null}
            </div>
        );
    }
}
